import { supabase } from '@/lib/supabase';
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from './useAuth';

export interface UserProfileData {
  id?: string;
  full_name?: string;
  avatar_url?: string;
  is_prestador?: boolean;
  [key: string]: unknown;
}

export function useUserProfile() {
  const { user, loading } = useAuth()
  const [profile, setProfile] = useState<UserProfileData | null>(null)
  const [profileLoading, setProfileLoading] = useState(true)

  // Função estável para carregar perfil
  const loadProfile = useCallback(async (userId: string) => {
    // Silenciar logs em produção e nas rotas de prestador
    const isPrestadorPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/prestador');
    const shouldLog = process.env.NODE_ENV !== 'production' && !isPrestadorPath;
    
    if (shouldLog) console.log('[useUserProfile] loading profile for user:', userId);
    
    setProfileLoading(true);
    
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', userId)
        .single();
        
      if (shouldLog) console.log('[useUserProfile] query result:', { data, error });
      
      setProfile(data);
      
      if (error && shouldLog) {
        console.error('[useUserProfile] query error:', error);
      }
    } catch (err) {
      if (shouldLog) console.error('[useUserProfile] unexpected error:', err);
    } finally {
      setProfileLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setProfile(null);
      setProfileLoading(false);
      return;
    }
    
    loadProfile(user.id);
  }, [user?.id, loadProfile]) // CORREÇÃO: Usar user.id em vez do objeto user completo

  return { userProfile: profile, loading: loading || profileLoading }
} 